import { FC } from 'react'

import { v1 } from 'uuid'

import { DEVICE_STORAGE_KEY } from 'common-constants/clientInfo'
import { resolveDeviceId } from 'functions/localStorage'

const ResolveUuid: FC = () => {
  const deviceId = resolveDeviceId()
  if (!deviceId || deviceId === 'null') {
    try {
      localStorage.setItem(DEVICE_STORAGE_KEY, v1())
    } catch (error) {
      // Ошибка с квотой на iOS
      // eslint-disable-next-line quotes
      console.error("Can't save to local storage")
    }
  }
  return null
}
export default ResolveUuid
